import { useMutation } from '@tanstack/react-query';

import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface CreateApplicantUploadVariables {
  interviewUid: string;
  documentName: string;
  documentDescription: string;
}

interface CreateApplicantUploadResponse {
  name: string;
  description: string;
}

const useCreateApplicantUpload = () => {
  const {
    mutateAsync: createApplicantUpload,
    data,
    isLoading,
    error,
  } = useMutation<
    CreateApplicantUploadResponse,
    Error,
    CreateApplicantUploadVariables
  >(
    ['createApplicantUpload'],
    async ({ interviewUid, documentName, documentDescription }) => {
      const body = {
        interview: interviewUid,
        name: documentName,
        description: documentDescription,
      };

      const response = await fetchWithCsrfToken<CreateApplicantUploadResponse>(
        'builder/async/document_requirement/update',
        'POST',
        body
      );

      return response;
    }
  );

  return {
    createApplicantUpload,
    data,
    isLoading,
    error,
  };
};

export default useCreateApplicantUpload;
